import { render, staticRenderFns } from "./TabPenibilite.vue?vue&type=template&id=1978ca28&"
import script from "./TabPenibilite.vue?vue&type=script&lang=js&"
export * from "./TabPenibilite.vue?vue&type=script&lang=js&"
import style0 from "./TabPenibilite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports